import React from 'react';
import "./index.css";

function GooeyProgressBar () {
	return (
		<>
			<div className="blobs">
				<div className="bar"/>
				<div className="blob"/>
			</div>

			<svg xmlns="http://www.w3.org/2000/svg" version="1.1" style={{height: 0}}>
				<defs>
					<filter id="goo">
						<feGaussianBlur in="SourceGraphic" stdDeviation="10" result="blur"/>
						<feColorMatrix in="blur" mode="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 18 -7"
						               result="goo"/>
						<feBlend in="SourceGraphic" in2="goo"/>
					</filter>
				</defs>
			</svg>
		</>
	)
}

export default GooeyProgressBar;